



import { fixedHtmlData } from "@/services/posts/postTypes/fixedhtml";
import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class FormatTextComponent extends Vue {
    @Prop() vsid!: string;
    @Prop() data!: fixedHtmlData[];

    get properties(): fixedHtmlData {
        return this.data.filter((x: fixedHtmlData) => x.id === this.vsid)[0];
    }
}
